import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// Firebase
import { db, functions } from '../../config/firebase-config';
import { collection, getDocs, getDoc, addDoc, updateDoc, doc, setDoc, deleteDoc, query, where, onSnapshot, orderBy, startAfter, limit } from 'firebase/firestore';

import { connect } from 'react-redux';

// Components - imported
import { Button } from '@material-ui/core';

// Icons
import LockIcon from '@material-ui/icons/Lock';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import RoomIcon from '@material-ui/icons/Room';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import CakeIcon from '@material-ui/icons/Cake';
import RateReviewIcon from '@material-ui/icons/RateReview';

// Displays if the user is logged in AND has set up profile
const ActivitySection = ({ 
    group: {
        group,
        loading
    }
}) => {

    // Users in last week
    const [newUserCount, setNewUserCount] = useState(null);
    const [gotNewUserCount, setGotNewUserCount] = useState(false);

    // Post count in last week
    const [postCount_LastWeek, setPostCount_LastWeek] = useState(null);
    const [gotPosts_LastWeek, setGotPosts_LastWeek] = useState(false);

    // Post count in last month
    const [postCount_LastMonth, setPostCount_LastMonth] = useState(null);
    const [gotPosts_LastMonth, setGotPosts_LastMonth] = useState(false);

    // Firebase collection ref
    const usersCollectionRef = collection(db, "users");
    const postsCollectionRef = collection(db, "posts");

    useEffect(() => {
        handleUpdateStats();
    }, [loading, group]);

    // -- GET COUNTS --
    const handleUpdateStats = async () => {
        if(loading || !group) return;

        // Get new followers within last week
        try {
            if(!gotNewUserCount) {
                // Calculate the date 7 days ago (1 week)
                let oneWeekAgo = new Date();
                oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);

                // Followers sub-collection ref
                const groupRef = doc(db, 'campuses', group._id);
                const followersCollectionRef = collection(groupRef, "followers");
    
                let q = query(followersCollectionRef, where("createdAt", ">=", oneWeekAgo));
    
                // Fetch new followers for group in last week
                const snapshot = await getDocs(q);
            
                setNewUserCount(snapshot.docs.length);
    
                setGotNewUserCount(true);
            }
        } catch (error) {
            console.log('Failed to get new followers within last week');
            console.log(error);
        }
    
        // Get new posts within last week
        try {
            if(!gotPosts_LastWeek) {
                // Calculate the date 7 days ago (1 week)
                let oneWeekAgo = new Date();
                oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
    
                let q = query(postsCollectionRef, where("group._id", "==", group._id), where("post_commented_on", "==", null), where("type", "==", "post"), where("createdAt", ">=", oneWeekAgo), orderBy('createdAt', 'desc'));
                
                const snapshot = await getDocs(q);
    
                setPostCount_LastWeek(snapshot.docs.length);
    
                setGotPosts_LastWeek(true);
            }   
        } catch (error) {
            console.log('Failed to get new posts within last week');
            console.log(error);
        }
    
        // Get new posts within last month
        try {
            if(!gotPosts_LastMonth) {
                // Calculate the date 1 month ago
                const oneMonthAgo = new Date();
                oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    
                let q = query(postsCollectionRef, where("group._id", "==", group._id), where("post_commented_on", "==", null), where("type", "==", "post"), where("createdAt", ">=", oneMonthAgo), orderBy('createdAt', 'desc'));
            
                const snapshot = await getDocs(q);
    
                setPostCount_LastMonth(snapshot.docs.length);
    
                setGotPosts_LastMonth(true);
            }
        } catch (error) {
            console.log('Failed to get new posts within last month');
            console.log(error);
        }
    }

    // Render the component
    return (
        <div style={{padding: '16px', borderBottom: '1px solid #e6ecf0'}}>
            <div style={{color:'rgb(15, 20, 25)', marginBottom: '1rem', fontWeight:'700', fontSize:'24px', lineHeight:'24px', overflowWrap:'break-word'}}>
                <span style={{fontSize: '1.125rem'}}>Activity</span>
            </div>
            
            <div style={{display: 'flex', alignItems: 'center', width: '100%', marginBottom: '1rem'}}>
                <RateReviewIcon/>
                <div style={{paddingLeft: '1rem', display: 'flex', flexDirection: 'column'}}>
                    <h5 style={{fontWeight: 500, fontSize: '1rem', marginBottom: '0.25rem'}}>
                        {(gotPosts_LastWeek) ? (postCount_LastWeek) : '--'} post{gotPosts_LastWeek === 1 ? '' : 's'} in the last week
                    </h5>
                    {(gotPosts_LastMonth && postCount_LastMonth > 0) && (
                        <h5 style={{fontWeight: 500, fontSize: '1rem', color: 'rgb(83, 100, 113)'}}>
                            {postCount_LastMonth} in the last month
                        </h5>
                    )}
                </div>
            </div>
            <div style={{display: 'flex', alignItems: 'center', width: '100%', marginBottom: '1rem'}}>
                <PeopleAltIcon />
                <div style={{paddingLeft: '1rem', display: 'flex', flexDirection: 'column'}}>
                    <h5 style={{fontWeight: 500, fontSize: '1rem', marginBottom: '0.25rem'}}>
                        {(group?.follower_count) ? (group.follower_count) : '--'} Members
                    </h5>
                    {/* <h5 style={{fontWeight: 500, fontSize: '1rem', color: 'rgb(83, 100, 113)'}}>
                        Members
                    </h5> */}
                    {(gotNewUserCount && newUserCount > 0) && (
                        <h5 style={{fontWeight: 500, fontSize: '1rem', color: 'rgb(83, 100, 113)'}}>
                            + {newUserCount} in the last week
                        </h5>
                    )}
                </div>
            </div>
        </div>
    )
}

// Prop types for the component
ActivitySection.propTypes = {

    // Prop type validation for function to toggle the Authentication modal
    nav: PropTypes.object.isRequired,
    group: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
    nav: state.nav,
    group: state.group
})

export default connect(mapStateToProps, { 

    // Connecting actions from Redux to the component
})(ActivitySection);
